import flashSale from "@faire/web-api/routes/flash-sale";
import { MediumFormatting } from "@faire/web/common/localization/formatting";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web/ui/ResponsiveContentV2";
import { observer } from "mobx-react";
import * as React from "react";
import type { JSX } from "react";

import { getIsApparelRetailer } from "@faire/retailer/serialized-data/getIsApparelRetailer";

const WarehouseSaleBannerBase: React.FC = () => (
  <Typography align="center">
    <ResponsiveContentV2
      mobile={
        <StrictLocalMsg
          defaultMessage="<MediumFormatting>Enjoy up to 60% off!</MediumFormatting> <LinkFormatting>Shop Warehouse Sale</LinkFormatting>"
          description={{
            text: "Nudge to let retailers know the seasonal warehouse sale is currently active",
          }}
          values={{
            MediumFormatting,
            LinkFormatting,
          }}
        />
      }
      tabletAndAbove={
        <StrictLocalMsg
          defaultMessage="<MediumFormatting>Our Warehouse Sale is happening now!</MediumFormatting> Enjoy up to 60% off. <LinkFormatting>Shop now</LinkFormatting>"
          description={{
            text: "Nudge to let retailers know the seasonal warehouse sale is currently active",
          }}
          values={{
            MediumFormatting,
            LinkFormatting,
          }}
        />
      }
    />
  </Typography>
);

const LinkFormatting = (chunk: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={
      getIsApparelRetailer()
        ? flashSale({
            "seasonal-warehouse-sales": "1",
            filters: "category:apparel",
          })
        : flashSale({ "seasonal-warehouse-sales": "1" })
    }
  >
    {chunk}
  </Button>
);

export const WarehouseSaleBanner = observer(WarehouseSaleBannerBase);
